import React, { useState, useEffect } from 'react';
import { pageTopPadding } from '../styles/layout';
import { joinLeagueWaitlist } from '../services/leagueWaitlistService';

const GOLD = '#C9A84C';
const BG = '#090909';
const TEXT_MUTED = '#F5F0E8';

const TheLeague = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const footer = document.querySelector('footer');
    if (footer) footer.style.display = 'none';
    return () => {
      if (footer) footer.style.display = '';
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = email.trim();
    if (!trimmed || submitting) return;

    setSubmitting(true);
    setError('');

    try {
      await joinLeagueWaitlist(trimmed);
      setSubmitted(true);
      setEmail('');
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="dd-page dd-league"
      style={{
        minHeight: '100vh',
        boxSizing: 'border-box',
        paddingTop: pageTopPadding(isMobile),
        backgroundColor: BG,
        background: 'radial-gradient(ellipse at center, rgba(201,168,76,0.25) 0%, rgba(9,9,9,1) 70%)',
      }}
    >
      <div
        style={{
          minHeight: `calc(100vh - ${pageTopPadding(isMobile)})`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: 'clamp(2rem, 6vw, 4rem)',
          boxSizing: 'border-box',
        }}
      >
        <span
          style={{
            display: 'block',
            fontSize: '0.75rem',
            fontWeight: '700',
            letterSpacing: '0.2em',
            color: GOLD,
            marginBottom: '1rem',
          }}
        >
          THE LEAGUE
        </span>

        <h1
          style={{
            fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
            fontWeight: '800',
            color: '#F5F0E8',
            lineHeight: 1.1,
            margin: '0 0 1.25rem',
            maxWidth: '16ch',
          }}
        >
          Something Big Is Coming
        </h1>

        <p
          style={{
            fontSize: isMobile ? '1rem' : '1.125rem',
            color: TEXT_MUTED,
            lineHeight: 1.65,
            margin: '0 auto 0',
            maxWidth: '32rem',
          }}
        >
          We&apos;re building a competitive golf league unlike anything in Phoenix. Be the first to
          know when we launch.
        </p>

        <div
          style={{
            width: '60px',
            height: '2px',
            backgroundColor: GOLD,
            margin: '2rem auto',
          }}
        />

        {submitted ? (
          <p
            style={{
              margin: 0,
              maxWidth: '28rem',
              fontSize: '1rem',
              color: GOLD,
              fontWeight: '600',
              lineHeight: 1.6,
            }}
          >
            You&apos;re on the list! We&apos;ll be in touch.
          </p>
        ) : (
          <form
            className="dd-waitlist-form"
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '0.75rem',
              width: '100%',
              maxWidth: '28rem',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'stretch',
                gap: '0.75rem',
              }}
            >
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                disabled={submitting}
                style={{
                  flex: 1,
                  width: isMobile ? '100%' : 'auto',
                  boxSizing: 'border-box',
                  backgroundColor: '#111111',
                  border: '1px solid rgba(201, 168, 76, 0.4)',
                  color: '#F5F0E8',
                  borderRadius: '999px',
                  padding: '0.75rem 1.5rem',
                  fontSize: '1rem',
                  outline: 'none',
                  opacity: submitting ? 0.7 : 1,
                }}
              />
              <button
                type="submit"
                disabled={submitting}
                style={{
                  width: isMobile ? '100%' : 'auto',
                  flexShrink: 0,
                  backgroundColor: GOLD,
                  color: '#000000',
                  border: 'none',
                  borderRadius: '999px',
                  padding: '0.75rem 1.5rem',
                  fontSize: '1rem',
                  fontWeight: '700',
                  cursor: submitting ? 'wait' : 'pointer',
                  whiteSpace: 'nowrap',
                  opacity: submitting ? 0.8 : 1,
                }}
              >
                {submitting ? 'Joining…' : 'Join the Waitlist'}
              </button>
            </div>
            {error && (
              <p
                role="alert"
                style={{
                  margin: 0,
                  fontSize: '0.875rem',
                  color: '#ef4444',
                  textAlign: 'left',
                }}
              >
                {error}
              </p>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default TheLeague;
